import { classes } from 'src/modules/shared/utils/styles.util';

export const DetailsSkeletonBlock = ({ className }: { className: string }) => (
  <div
    className={classes('animate-pulse rounded bg-secondary-100', className)}
  />
);
